const API_URL = "https://nanosoft.technology/resturant_backend/api";

export default API_URL;